// @core/api/endpoints/payment/get_payment_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentPolicyResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment policy
 * Retrieves payment policy by the specified identifier.
 */
export async function GetPaymentPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<PaymentPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<PaymentPolicyResponse>(requestPath, { ...requestOptions });
}
